import { Box, Link, styled } from "@mui/material";

export const Footer = () => {
  return <Box sx={{
    display: 'flex',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2,
    color: '#5E677B',
    mx: 1,
  }}>
    <span>©2025 Hanko GmbH</span>
    <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: 2,
      textDecoration: 'none'
    }}>
      <FooterLink href="https://www.hanko.io/support">Support</FooterLink>
      <FooterLink href="https://www.hanko.io/privacy">Privacy</FooterLink>
      <FooterLink href="https://www.hanko.io/terms">Terms</FooterLink>
    </Box>
  </Box>
}

const FooterLink = styled(Link)({
  textDecoration: 'none',
  color: '#5E677B',
})